import Divider from "@mui/material/Divider";
import styled from "@mui/system/styled";

export const DividerStyled = styled(Divider)`
  margin-top: 10px;
  margin-left: calc(50% - 110px);
  margin-right: calc(50% - 110px);
  border-width: 5px;
  border-radius: 5px;
`;
